var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tk-cell-box"},[_vm._t("default"),_vm._v(" "),(!_vm.data.length)?_c('div',{staticClass:"tk-box-nodata"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }